/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable camelcase */
/* eslint-disable no-console */
import React, { useState } from "react";
// import IconButton from "@mui/material/IconButton";
// import AddBoxIcon from "@mui/icons-material/AddBox";
// import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

function ToppingCustomization(props) {
  const [isToppingSelected, selectTopping] = useState(false);
  const { name, item_id, updateToppingList, topping } = props;
  return (
    <Fade
      style={{ transformOrigin: "0 0 0" }}
      timeout={500}
      in
      appear
      key={item_id}
    >
      <Box sx={{ m: 1, marginLeft: "40%" }}>
        <FormControlLabel
          id={item_id}
          checked={isToppingSelected}
          label={name}
          control={
            <Checkbox
              onChange={() => {
                selectTopping(!isToppingSelected);
                updateToppingList(topping, !isToppingSelected);
              }}
            />
          }
          color='success'
        />
        <br />
        <br />
      </Box>
    </Fade>
  );
}

ToppingCustomization.propTypes = {
  item_id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  updateToppingList: PropTypes.func.isRequired,
  topping: PropTypes.shape({}).isRequired,
};

export default ToppingCustomization;
